import { useMutation } from '@tanstack/react-query';
import { apiClient } from './client';
import { handleApiError } from './axiosConfig';

export interface NewsletterSignupData {
  email: string;
  zip_code?: string;
}

export interface NewsletterSignupResponse {
  success: boolean;
  message: string;
}

export const useNewsletterSignup = () => {
  return useMutation({
    mutationFn: async (data: NewsletterSignupData): Promise<NewsletterSignupResponse> => {
      try {
        return await apiClient.post<NewsletterSignupResponse>('/api/contact/subscribe', data);
      } catch (error) {
        const errorMessage = handleApiError(error);
        console.error('Failed to subscribe to newsletter:', errorMessage);
        throw new Error(errorMessage);
      }
    },
  });
};

